import Column from './Column.js'

export default class Table {
    get CLASS() { return 'Table' }
    constructor(name=undefined) {
        this.name = name
        this.pknm = undefined
        this.cols = []
        this.rows = []
        this.isLoaded = false
        this.isParsed = false
        this.numParsed = 0
        // TODO and check table function (correct rowNames vs colNames, etc.)
    }
    set(tbl={}) {
        return this.parse(tbl)
    }
    upd(tbl={}) {
        this.name = tbl.name !==undefined ? tbl.name : this.name
        this.pknm = tbl.pknm !==undefined ? tbl.pknm : this.pknm // TODO check?
        (tbl.cols || []).forEach(col => this.colUpd(col))
        (tbl.rows || []).forEach(row => this.rowUpd(row))
        return this
    }
    copy(opts={withCols: true, withRows: true}) {
        let tbl = {name: this.name, pknm: this.pknm , opts}
        if(opts.withCols)
            tbl.cols = this.cols.map(col => col.copy())
        if(opts.withRows)
            tbl.rows = this.rows // TODO Should it be a real copy?
        return tbl
    }
    parse(tbl={}) {
        this.name = tbl.name
        this.pknm = tbl.pknm
        if(!tbl.opts || tbl.opts.withCols) {
            // TODO what if columns changed (rows may be not correct!)
            // TODO check default depends on tbl.rows present
            this.cols.splice(0);
            (tbl.cols || []).forEach(col => this.colAdd(col, undefined, false))
        }
        if(!tbl.opts || tbl.opts.withRows) {
            this.rows.splice(0);
            (tbl.rows || []).forEach(row => this.rowAdd(row))
        }
        return this
    }
    getColInd(colName=undefined, thrErr=true) {
        `
            Search index of the column and return it if found,
            or raise error if thrErr,
            or return index of the last column (is -1 if empty!)
        `
        const ind = this.cols.findIndex(col => col.name === colName)
        if(ind < 0 && thrErr)
            throw `Column "${colName}" does not exist`
        return ind >= 0 ? ind : this.cols.length - 1
    }
    getRowInd(rowName=undefined, thrErr=true) {
        `
            Search index of the row and return it if found,
            or raise error if thrErr,
            or return index of the last row (is -1 if empty!)
        `
        if(!this.pknm)
            throw `Primary key is not set`
        const ind = this.rows.findIndex(row => row[this.pknm] == rowName)
        if(ind < 0 && thrErr)
            throw `Row "${rowName}" does not exist`
        return ind >= 0 ? ind : this.rows.length - 1
    }
    col(colName) {
        const j = this.getColInd(colName)
        return this.cols[j]
    }
    colAdd(col, colNameBefore=undefined, deftCheck=true) {
        col = new Column().parse(col).check()
        const colName = col.name
        if(this.cols.find(col => col.name == colName))
            throw `Column "${colName}" is already exist`
        if(col.isPk && this.cols.find(col => col.isPk))
            throw `Can't add second pk "${colName}"`
        if(col.deft !== undefined && col.deft !== null)
            this.rows.forEach(row => {row[colName] = col.deft})
        else if(deftCheck && this.rows.length && col.isNotNull)
            throw `Default value for column "${colName}" is required`
        const j = this.getColInd(colNameBefore, false) + 1
        this.cols.splice(j, 0, col)
        this.pknm = col.isPk ? col.name : this.pknm
    }
    colUpd(col, colNameBefore=undefined) {
        const j = this.getColInd(col.name)
        if(!this.cols[j].isPk && col.isPk === true)
            throw `Can't update to pk "${col.name}"`
        if( this.cols[j].isPk && col.isPk === false)
            throw `Can't delete pk while update "${col.name}"`
        col = new Column().parse(this.cols[j]).upd(col).check()
        if(!colNameBefore)
            this.cols[j] = col
        else {
            const jNew = this.getColInd(colNameBefore, false) + 1
            this.cols.splice(j, 1)
            this.cols.splice(jNew, 0, col)
        }
    }
    colDel(colName) {
        const j = this.getColInd(colName)
        if(this.cols[j].isPk)
            throw `Can't delete pk column "${colName}"`
        this.rows.forEach(row => {delete row[colName]})
        this.cols.splice(j, 1)
    }
    row(rowName) {
        const i = this.getRowInd(rowName)
        return this.rows[i]
    }
    rowAdd(row, rowNameBefore=undefined) {
        const rowName = row[this.pknm]
        const i = this.getRowInd(rowNameBefore, false) + 1
        if(this.rows.find(row => row[this.pknm] == rowName))
            throw `Row "${rowName}" is already exists`
        this.cols.forEach(col => {
            const colName = col.name
            const val = col.prepareVal(row[colName])
            if(val !== undefined && val !== null)
                row[colName] = val
            else
                delete row[colName]
        })
        this.rows.splice(i, 0, row)
    }
    rowUpd(row) {
        const rowName = row[this.pknm]
        const i = this.getRowInd(rowName)
        Object.entries(row).forEach(([colName, val]) => {
            const col = this.cols[this.getColInd(colName)]
            row[colName] = col.prepareVal(val)
        })
        Object.entries(row).forEach(([colName, val]) => {
            if(val !== undefined && val !== null)
                this.rows[i][colName] = val
            else
                delete this.rows[i][colName]
        })
    }
    rowDel(rowName) {
        const i = this.getRowInd(rowName)
        this.rows.splice(i, 1)
    }
    val(colName, rowName) {
        const i = this.getRowInd(rowName)
        const j = this.getColInd(colName)
        return this.rows[i][colName]
    }
    valUpd(colName, rowName, val=undefined, old=undefined) {
        const i = this.getRowInd(rowName)
        const j = this.getColInd(colName)
        const col = this.cols[j]
        val = col.prepareVal(val)
        if(old !== undefined && old !== this.rows[i][colName])
            throw `Old value is not correct`
        if(val !== undefined && val !== null)
            this.rows[i][colName] = val
        else
            delete this.rows[i][colName]
    }
    extend(tblRef) {
        if(!this.isLoaded || this.isParsed || !tblRef.isLoaded)
            return
        this.cols.forEach(col => {
            if(!col.fkTbl || col.fkTbl != tblRef.name)
                return
            if(this.name=='papers') console.log('parse')
            this.rows.forEach(row => {
                let rowRef = undefined
                try {
                    row[col.name] = tblRef.row(row[col.name])
                }
                catch(err) {}
            })
            this.numParsed+= 1
        })
        if(this.numParsed == this.cols.filter(c => c.fkTbl).length)
            this.isParsed = true
        if(this.name=='papers') {
            console.log('extend ', this.name, tblRef.name, this.isParsed, this.cols.filter(c => c.fkTbl).length)
        }
    }
    str(withCols=false, cellLen=12) {
        let M = this.cols.length
        let r = ('-'.repeat(cellLen) + '--').repeat(M) + '\n'
        let s = withCols ?  this.strCols() : ``
        s+= `\n    Content of the table ${this.name}\n` + r
        this.cols.map(col => col.name).forEach(v => {
            s+= ' ' + v + ' '.repeat(Math.max(0, cellLen-v.length-1)) + ' |'
        })
        s+= '\n' + r
        for(let row of this.rows) {
            for(let col of this.cols) {
                let v = row[col.name]
                v = v === undefined ? 'UNDEF' : v
                v = v === null ? 'NULL' : v.toString()
                s+= ' '+v+' '.repeat(Math.max(0, cellLen-v.length-1))+' |'
            }
            s+= '\n'
        }
        return s + r
    }
    strCols() {
        const esc = name => `'${name}'`
        const escId = name => `'${name}'`
        let s = `\n    Columns of the table ${this.name}\n`
        this.cols.forEach(col => {
            let sql = col.buildMySQL(esc, escId)
            let sql_fk = col.buildMySQL_fk(esc, escId)
            if(sql_fk)
                sql+= ' '.repeat(Math.max(0, 30-sql.length)) + `  || FK: `
            s+= sql + sql_fk + `\n`
        })
        return s
    }
}



// WEBPACK FOOTER //
// ./src/database/Table.js